class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
      this.cartDrawerItems = this.querySelector('cart-drawer-items')
      this.addEventListener("click", (event) => {
        if(event.target.classList.contains('td-product-card__slide-atc-btn')) {
         this.onQuickAdd(event)
        
        }
    })
    }
    onQuickAdd = (event) => {
      let formData = {
        'items': [{
         'id': event.target.dataset.product,
         'quantity': 1
         }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
        })
        .then(response => {   
            
            return response.json();
        })
        .then(res => {
          this.reRenderCart(res.items[0].id,1)           
        })
        .catch((error) => {
            console.error('Error:', error);
        })
    }

    reRenderCart(productId,value) {
      const payload = {};
      payload.updates = {};
      payload.updates[productId] = value;
      payload.sections = this.getSectionsToRender().map((section) => section.id);
      return fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }            
          this.renderContents(response);
          
        });
    }
    

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#td-cart-icon-bubble');
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {this.classList.add('animate', 'active')});
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('TdCartDrawer');
        const focusElement = this.querySelector('.td-drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
      
      document.body.classList.add('overflow-hidden');
      const header = document.querySelector('#shopify-section-td-header')      
      if(header.classList.contains('menu-open')) {        
        document.dispatchEvent(new CustomEvent('open-mini-cart'))
      }
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
      this.recommendedProducts = document.querySelector("[data-cart-recommended-products]");
      if(this.recommendedProducts) {
        const renderCart = new Event('render-cart'); 
        this.recommendedProducts.dispatchEvent(renderCart);
      }

    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'td-cart-drawer-inner',
          selector: '#TdCartDrawerInner'
        },
        {
          id: 'td-cart-icon-bubble'
        }
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'TdCartDrawerInner',
          section: 'td-cart-drawer-inner',
          selector: '.td-cart-drawer__inner'
        },
        {
          id: 'td-cart-icon-bubble',
          section: 'td-cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);
  